import moment from 'moment'

export default {
  methods: {
    date_to_label (fecha) {

      try {
        if (fecha) {

          if (moment.tz(fecha, localStorage.time_zone).lang("es").format('YYYY-MM-DD') == new moment().format('YYYY-MM-DD')) {
            return moment.tz(fecha, localStorage.time_zone).lang("es").format('hh:mm a');
          } 
          else if (moment.tz(fecha, localStorage.time_zone).lang("es").format('YYYY') == new moment().format('YYYY')) {
            return moment.tz(fecha, localStorage.time_zone).lang("es").format('DD MMM');
          } else {
            return moment.tz(fecha, localStorage.time_zone).lang("es").format('DD MMM YY');
          }
          
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }

      //return "Hoy"
    },
    datediff (date1, date2) {
      if (date1 == null || date2 == null) {
        return 1 * 60 * 60 * 1000
      } else {
        return (new Date(date2).getTime() - new Date(date1).getTime() + (1 * 24 * 60 * 60 * 1000));
      }
    },
    project_start_date (startdate) {
      if (startdate == null) {
        const hours = 10;
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();
        const currentDay = currentDate.getDate();
        const timeStamp = new Date(currentYear, currentMonth, currentDay, 0, 0, 0).getTime();

        return new Date(timeStamp + hours * 60 * 60 * 1000).getTime();
      } else {
        return moment.tz(startdate, localStorage.time_zone).valueOf();
      }
    },
    formatTimeToSeconds (seconds) {
      try {

        if (seconds) {
          if (seconds != null && seconds != undefined && seconds != '' && isNaN(seconds) && seconds != 'NaN') {
            var hours = Math.floor( parseInt(seconds) / 3600 )
            var minutes = Math.floor( (parseInt(seconds) - (hours * 3600)) / 60 )

            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;

            return hours + 'h ' + minutes + 'm'
          } else {
            return '00h 00m'
          }
        } else {
          return '00h 00m'
        }

      } catch (error) {
        this.showError(error)
      }
    },
    formatMoney (amount) {
      try {
        if (amount) {
          const negativeSign = amount < 0 ? "-" : "";
          let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(2)).toString();
          let j = (i.length > 3) ? i.length % 3 : 0;
          return negativeSign + (j ? i.substr(0, j) + "," : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") + (i.length == 2 ? "." + Math.abs(amount - i).toFixed(2).slice(2) : "");
        } else {
          return "0.00"
        }
      } catch (error) {
        console.log(error)
        return "0.00"
      }
    },
    formatDateTime (fecha) {
      try {
        if (fecha) {
          return moment.tz(fecha, localStorage.time_zone).format('DD/MM/YYYY hh:mm a');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    formatDate (fecha) {
      try {
        if (fecha) {
          return moment.tz(fecha, localStorage.time_zone).format('DD/MM/YYYY');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    formatTime (fecha) {
      try {
        if (fecha) {
          return moment.tz(fecha, localStorage.time_zone).format('hh:mm a');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    formatDateForInput (fecha) {
      try {
        if (fecha) {
          return moment.tz(fecha, localStorage.time_zone).format('YYYY-MM-DD');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    formatDatetimeForInput (fecha) {
      try {
        if (fecha) {
          return moment.tz(fecha, localStorage.time_zone).format('YYYY-MM-DDTHH:mm:ss');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    datePickerToUTC (fecha) {
      try {
        if (fecha) {
          return moment.tz(fecha + " 00:00:00", localStorage.time_zone).utc().format('DD/MM/YYYY HH:mm:ss');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    datePickerFormToUTC (fecha) {
      try {
        if (fecha) {
          fecha = new moment(fecha).utc().format('YYYY/MM/DD HH:mm:ss')
          return moment(fecha).utc().format('DD/MM/YYYY HH:mm:ss');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    datePickerFormToUTC_End (fecha) {
      try {
        if (fecha) {
          fecha = new moment(fecha).utc().format('YYYY/MM/DD 23:59:59')
          return moment(fecha).utc().format('DD/MM/YYYY HH:mm:ss');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    datetimePickerToUTC (fecha) {
      try {
        if (fecha) {
          return moment.tz(fecha, localStorage.time_zone).utc().format('DD/MM/YYYY HH:mm:ss');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    dateRangePickerMask (fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },
    dateRagePickerToUTC (fecha) {
      try {
        if (fecha) {
          return moment.tz(fecha, 'UTC').format('YYYY/MM/DD HH:mm:ss');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    getTodayToUTC_Ini (v_dateadd) {
      try {
        var fecha = new Date()
        fecha.setHours('00')
        fecha.setMinutes('00')
        fecha.setSeconds('00')

        return moment(fecha).add((v_dateadd != undefined)?v_dateadd:0, 'days').utc().format('YYYY/MM/DD HH:mm:ss');
      } catch (error) {
        this.showError(error)
      }
    },
    getTodayToUTC_Fin () {
      try {
        var fecha = new Date()
        fecha.setHours('23')
        fecha.setMinutes('59')
        fecha.setSeconds('59')

        return moment(fecha).utc().format('YYYY/MM/DD HH:mm:ss');
      } catch (error) {
        this.showError(error)
      }
    },

    
    /*dateRagePickerToUTC_Ini (fecha) {
      try {
        if (fecha) {
          console.log(fecha)
          console.log(moment.tz(fecha.substring(0,10) + ' 00:00:00', 'UTC').format('YYYY/MM/DD HH:mm:ss'))
          return moment.tz(fecha.substring(0,10) + ' 00:00:00', 'UTC').format('YYYY/MM/DD HH:mm:ss');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },
    dateRagePickerToUTC_Fin (fecha) {
      try {
        if (fecha) {
          console.log(fecha)
          console.log(moment.tz(fecha.substring(0,10) + ' 23:59:59', 'UTC').format('YYYY/MM/DD HH:mm:ss'))
          return moment.tz(fecha.substring(0,10) + ' 23:59:59', 'UTC').format('YYYY/MM/DD HH:mm:ss');
        } else {
          return fecha
        }
      } catch (error) {
        this.showError(error)
      }
    },*/

  }
};